__turbopack_context__.v({
  "load-more": "LoadMore-module-scss-module__23YtEq__load-more",
  "load-more__count": "LoadMore-module-scss-module__23YtEq__load-more__count",
});
